












































































import { Vue, Component, Prop } from 'vue-property-decorator';

import { Surface, Typography } from '@/components/atoms';
import CalendarIcon from '@/components/icons/Calendar.vue';
import TogglesIcon from '@/components/icons/Toggles.vue';
import CircleBlock from '@/components/icons/CircleBlock.vue';
import InfoIcon from '@/components/icons/Info.vue';
import PlusCircleIcon from '@/components/icons/PlusCircle.vue';
import SpecialCoinIcon from '@/components/icons/SpecialCoin.vue';
import IDCard from '@/components/icons/IDCard.vue';
import CoinsIcon from '@/components/icons/Coins.vue';
import CircleCancel from '@/components/icons/CircleCancel.vue';

import flagKeys from '@/constants/flagKeys';

import { renderTextWithLinks } from '@/utils/renderTextWithLinks';
import { getLabelInfo } from '@/utils/getLabelInfo';
import { ILocation } from '@/models/location';
import { ModalOptionsV2 } from '@/components/Modal/ModalOptions';
import eventBus from '@/utils/eventBus';
import InStoreIcon from '@/components/icons/InStore.vue';

@Component({
  components: {
    Surface,
    Typography,
    CalendarIcon,
    TogglesIcon,
    InfoIcon,
    PlusCircleIcon,
    SpecialCoinIcon,
    IDCard,
    CircleBlock,
    CoinsIcon,
    CircleCancel,
    InStoreIcon
  }
})
export default class BirthdayCoinSettings extends Vue {
  @Prop() offer!: Record<string, any>;
  @Prop({ default: true }) showRestrictions?: boolean;
  @Prop({ default: true }) showOtherRules?: boolean;
  @Prop({ default: () => [] }) locations?: Array<ILocation>;

  get tPrefix() {
    return 'offers.form';
  }

  get flags() {
    return this.$store.getters['flags/getFlags'] || [];
  }

  get restrictionFieldIsActivated() {
    return this.flags.includes(flagKeys.offerRestrictionField);
  }

  get coinsLabel() {
    return this.$t(`${this.tPrefix}.coinRule.overview`, {
      coinLimit: 1,
      coin: this.$tc('common.pluralize.offer', 1)
    });
  }

  get idCardLabel() {
    return this.$t(`${this.tPrefix}.idCardOverview`);
  }

  get expirationLabel() {
    return this.$t(`${this.tPrefix}.expirationRule.overviewBirthday`);
  }

  get combineLabel() {
    return this.$t(`${this.tPrefix}.combineRule.overview`);
  }

  get restrictionsLabel() {
    const label =
      (this.offer && this.offer.restrictions) ||
      this.$t(`${this.tPrefix}.coinRule.noRestrictions`);

    const openInNewTab = true;

    return renderTextWithLinks(label, openInNewTab);
  }

  get redeemableInOtherLocationsLabel() {
    const [, ...otherLocations] = this.locations || [];

    if (!otherLocations.length) return '';

    return `+ ${otherLocations.length} ${this.$tc(
      'common.pluralize.location',
      otherLocations.length
    )}`;
  }

  get hasLocations() {
    return this.locations && this.locations.length;
  }

  get redeemableLabel() {
    const locations = this.locations || [];

    const [firstLocation] = locations;

    const label =
      (firstLocation && firstLocation.name) ||
      getLabelInfo(['address', 'city'], firstLocation);

    return this.hasLocations
      ? `${this.$t(`${this.tPrefix}.otherRules.redeemableInStore`)} at ${label}`
      : String(this.$t(`${this.tPrefix}.otherRules.redeemableInStore`));
  }

  handleOpenLocationsGroupModal() {
    eventBus.$emit(
      'openSubModal',
      new ModalOptionsV2({
        icon: 'none',
        hideCancelButton: true,
        confirmEvent: '',
        componentToRender: 'locationsGroupedByCityModal'
      }),
      {
        title: 'Redeem locations',
        locations: this.locations
      }
    );
  }
}
